/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */

// suggest improvements for this component
// give me the entire code to copy
// ran this thru claudes code refactoring tool
// ran this thru claudes design


// redesign this component to look more elegant and polished
// use tailwind css in the className directive 
// Use Tailwind CSS className only. Preserve all logic, Redux hooks, and routing exactly as-is.

// Design language:
// - Aesthetic: Soft & friendly — rounded corners (rounded-2xl, rounded-full), warm and airy
// - Spacing: Generous padding, breathing room between elements
// - Typography: Small-medium text (text-sm, text-xs), font-semibold for labels, uppercase tracking-widest for headings
// - Colors: All colors come from dynamic seller props (sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1) — never hardcode brand colors
// - Backgrounds: Use color + opacity modifiers (e.g. sellerPrimaryColor1 + '12' for tinted fills, + '30' for borders, + '40' for backgrounds)
// - Shadows: shadow-sm on cards, shadow-md on hover, shadow-xl on dropdowns/modals
// - Borders: Always use sellerPrimaryColor1 + '30' or '40' opacity — never solid opaque borders
// - Buttons: Rounded-2xl, solid fill for primary actions; bordered ghost style for secondary actions
// - Hover states: hover:bg-white/60, hover:scale-105, hover:shadow-md — always transition-all duration-200
// - Dropdowns/overlays: rounded-2xl, shadow-xl, border border-white/60, backdrop-blur-sm
// - Badges/counts: Absolute positioned, rounded-full, bg-rose-400 text-white, -top-1.5 -right-1.5
// - Icons: Always paired with text labels or tooltips, sized text-sm to text-xl
// - Active states: Tinted background (primaryColor + '12') rather than just a color change
// - Animations: Smooth transitions — max-h + opacity for reveals, scale for interactive elements
// - Mobile sidebar: duration-300 ease-out, backdrop-blur-[2px] overlay
// "Colors come from dynamic seller props — use hex + opacity string concatenation (e.g. sellerPrimaryColor1 + '20') for tints, never hardcode colors."

// Use Tailwind CSS className only. Preserve all logic, Redux hooks, and routing exactly as-is.
// Give me the complete code with instructions

// ask me a series of questions to gather additional context you need to best achive this task



import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { FaFacebookF, FaLinkedin, FaGithub } from "react-icons/fa";
import { FaTwitter, FaHeart, FaCartShopping } from "react-icons/fa6";
import { MdOutlineRestaurantMenu } from "react-icons/md";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { BsEnvelopeOpenFill } from "react-icons/bs";
import { IoShieldHalfOutline } from "react-icons/io5";
import { BiSolidCoupon } from "react-icons/bi";

import { get_event_details } from '../store/reducers/eventDetailsReducer';
import { newsletterSubscriber_register, messageClear } from '../store/reducers/newsletterSubscriberReducer';

import SiteBadge from './SiteBadge';
import { toTitleCase } from '../components/toTitleCase';
import GetSellerConfig from './GetSellerConfig';

import toast from 'react-hot-toast';
import { formatPhoneNumber } from 'react-phone-number-input';

import config from '../config';

const KOSHER_LOGO_MAP = {
    OU:  '/images/kashrus/OU-Logo-Footer.png',
    CRC: '/images/kashrus/CRC-Logo-Footer.png',
    KCL: '/images/kashrus/KCL-Logo-Footer.png',
};

const CONTACT_EMAIL = 'mailto:kosher.caterer@inbox.lv?subject=I Would Like More Info About Kosher Caterer Website Software';

const Footer = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL;

    const { seller }                             = useSelector(state => state.seller);
    const { userInfo }                           = useSelector(state => state.auth);
    const { cart_product_count, wishlist_count } = useSelector(state => state.cart);
    const { errorMessage, successMessage }       = useSelector(state => state.newsletterSubscriber);
    const { eventDetails }                       = useSelector(state => state.eventDetails);
    const isCouponValid = Boolean(eventDetails?.coupon) && (!eventDetails?.couponExpirationDate || new Date(eventDetails?.couponExpirationDate) > new Date());
    
    //console.log('eventDetails', eventDetails);
    const [email, setEmail] = useState('');

    //const { sellerComponentBackgroundColor } = GetSellerConfig();

    const { 
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, 
        sellerOtherWebsiteURL2, sellerOtherWebsiteName2, sellerProductPluralTerm,
        sellerCompanyPhoneNumber, sellerCompanyLogo, sellerSellerImage, sellerCompanyEmailAddress, sellerCompanyKosherSupervision1, 
        sellerCompanyKosherSupervision2, sellerMainIngredientPluralTerm, sellerTaglineTop1, sellerTaglineTop2, 
        personalServiceTagLine, sellerMarketingLine1, sellerHolidayHeader, sellerOwnerNames,
        sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia
    } = GetSellerConfig();

    
    const kosherLogo1 = KOSHER_LOGO_MAP[sellerCompanyKosherSupervision1] ?? '';
    const kosherLogo2 = KOSHER_LOGO_MAP[sellerCompanyKosherSupervision2] ?? '';

    const ownerNames = useMemo(() => {
        const raw = sellerOwnerNames ?? '';
        return raw.includes(';') ? raw.split(';') : raw ? [raw] : [];
    }, [sellerOwnerNames]);
    
    const s = seller ?? {};
    
    const currentYear = new Date().getFullYear();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleChatClick = () => {
        navigate(userInfo ? '/customerDashboard/chat' : '/login');
    };

    const handleNewsletterSubmit = (e) => {
        e.preventDefault();
        dispatch(newsletterSubscriber_register({
            webSiteOrigin: sellerFrontendURL,
            email,
            isSubscribed: true,
        }));
        setEmail('');
    };

    useEffect(() => {
        if (userInfo) {
            dispatch(get_event_details(userInfo.id));
        }
    }, [userInfo, dispatch]);
    
    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage);
            dispatch(messageClear());
        }
        if (errorMessage) {
            toast.error(errorMessage);
            dispatch(messageClear());
        }
    }, [successMessage, errorMessage, dispatch]);

    // Divider rendered between columns — a vertical gradient line
    //hidden 
    const ColumnDivider = () => (
        <div className="sm:hidden flex items-stretch px-0 self-stretch">
            <div
                className="w-px self-stretch"
                style={{
                    background: `linear-gradient(to bottom, transparent 0%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 20%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 80%, transparent 100%)`,
                }}
            />
        </div>
    );

    return (
        <footer
            className="relative overflow-hidden"
            style={{ 
                backgroundColor: sellerComponentBackgroundColor, 
                color: sellerPrimaryColor1 + sellerColorSuffixDark 
            }}>
            {/* ── Main section ── */}
            <div className="w-[88%] max-w-6xl mx-auto py-12">
                {/* ── Horizontal rule ── */}
                <div
                    className="mt-4 mb-4 h-px w-full"
                    style={{
                        background: `linear-gradient(to right, transparent 0%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 20%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 80%, transparent 100%)`,
                    }}
                />
                {/* 3-equal-column row with inline dividers */}
                <div className="flex items-stretch gap-0 sm:flex-col sm:gap-8">

                    {/* ══ Column 1 — About Us ══ accent bar */}
                    <div className="flex-1 px-8 sm:px-0 flex flex-col gap-3">
                        <div className='flex gap-2 items-center mb-1'>
                            <div
                                className="w-[5px] h-5 rounded-full"
                                style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixMedium }}
                                />
                            <div
                                className="text-[14px] font-semibold uppercase tracking-[0.2em]"
                                style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                About Us
                            </div>
                        </div>
                        {/* Logo + portrait */}
                        <div className="">
                            <div className="flex items-center gap-3">
                                {sellerCompanyLogo && (
                                    <img
                                        className="h-11 object-contain flex-shrink-0"
                                        src={sellerCompanyLogo}
                                        alt={`${sellerShopName} logo`}
                                    />
                                )}
                                {sellerSellerImage && (
                                    <img
                                        className="w-11 h-11 rounded-xl object-cover"
                                        style={{ border: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixMedium}` }}
                                        src={sellerSellerImage}
                                        alt={`${sellerShopName} seller`}
                                    />
                                )}
                            </div>
                        </div>
                        {/* Owner names */}
                        {ownerNames.length > 0 && (
                            <div>
                                <div className="text-sm font-semibold" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                    {ownerNames.map((name, i) => (
                                        <span key={i}>
                                            {toTitleCase(name)}{i < ownerNames.length - 1 ? ', ' : ''}
                                        </span>
                                    ))}
                                </div>
                                <div className="text-xs mt-0.5" style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                    At Your Service!
                                </div>
                            </div>
                        )}

                        {/* Kosher certification — highlighted badge */}
                        {/* flex items-center gap-3 px-4 py-3 rounded-2xl mt-auto w-fit 
                            <IoShieldHalfOutline size={20} /> <div>
                                kosher
                                </div>
                        */}
                        {(kosherLogo1 || kosherLogo2) && (
                            <div className="bg-white w-fit">
                                <div className="px-4 py-3 rounded-2xl w-fit"
                                    style={{
                                            backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                            border: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixMedium}`,
                                        }}>
                                    <div
                                        className="flex items-center gap-1 px-0 py-0 rounded-2xl w-fit">
                                        <IoShieldHalfOutline size={26} style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }} />
                                        <div
                                            className="text-[20px] font-semibold"
                                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                            Kosher
                                        </div>
                                    </div>
                                    <div
                                        className="mt-0.5 mb-0.5 h-px w-full"
                                        style={{
                                            background: `linear-gradient(to right, transparent 0%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 20%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 80%, transparent 100%)`,
                                        }}
                                    />
                                    <div
                                        className="flex items-center gap-3 px-0 py-2 rounded-2xl w-fit">
                                        {kosherLogo1 && (
                                            <img
                                                src={kosherLogo1}
                                                alt={`${s.kosherSupervision1} certification`}
                                                className="h-7 object-contain"
                                            />
                                        )}
                                        {kosherLogo2 && (
                                            <img
                                                src={kosherLogo2}
                                                alt={`${s.kosherSupervision2} certification`}
                                                className="h-7 object-contain"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Vertical divider 1 */}
                    <div
                        className="w-px self-stretch sm:hidden"
                        style={{
                            background: `linear-gradient(to bottom, transparent 0%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 18%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 82%, transparent 100%)`,
                        }}
                    />

                    {/* ══ Column 2 — Contact Info ══ */}
                    <div className="flex-1 px-8 sm:px-0 flex flex-col gap-3">
                        <div className='flex gap-2 items-center mb-1'>
                            <div
                                className="w-[5px] h-5 rounded-full"
                                style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixMedium }}
                                />
                            <div
                                className="text-[14px] font-semibold uppercase tracking-[0.2em]"
                                style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                Contact Info
                            </div>
                        </div>
                        <p className="text-xl font-semibold" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                            {s.shopName}
                        </p>

                        {/* Address inset */}
                        <div className="bg-white">
                            <div
                                className="rounded-xl px-4 py-3 flex flex-col gap-1"
                                style={{
                                    backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                    border: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixMedium}`,
                                }}>
                                <p className="text-sm" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                    {s.address1}{s.address2 ? ` ${s.address2}` : ''}
                                </p>
                                <p className="text-sm" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                    {s.city}, {s.sellerState} {s.zipCode}
                                </p>
                            </div>
                        </div>
                        {/* Contact detail rows */}
                        <ul className="flex flex-col gap-2">
                            {[
                                { label: 'Phone',   value: formatPhoneNumber(s.phoneNumber) },
                                { /*label: 'Contact', value: s.contactPerson*/ },
                                { label: 'Email',   value: s.emailAddress },
                            ].map(({ label, value }) => value && (
                                <li key={label} className="flex items-baseline gap-2 text-sm">
                                    <span
                                        className="text-[10px] font-semibold uppercase tracking-wider w-14 flex-shrink-0"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                        {label}
                                    </span>
                                    <span className="font-medium" style={{ color: sellerPrimaryColor1 }}>
                                        {value}
                                    </span>
                                </li>
                            ))}
                        </ul>

                        {/* Chat CTA */}
                        {sellerBoolShowSiteChat && (
                            <button
                                onClick={handleChatClick}
                                className="mt-auto flex items-center justify-center gap-2 px-5 py-3 rounded-2xl text-sm font-semibold text-white shadow-sm hover:shadow-md hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 cursor-pointer w-full"
                                style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                <IoChatbubbleEllipsesSharp className="text-base" />
                                Chat With Us
                            </button>
                        )}

                        {sellerOtherWebsiteURL2 && (
                            <div className="hidden text-center">
                                <Link
                                    className="text-xs font-medium hover:underline transition-all duration-150"
                                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    to={sellerOtherWebsiteURL2}>
                                    {sellerOtherWebsiteName2}
                                </Link>
                            </div>
                        )}
                    </div>

                    {/* Vertical divider 2 */}
                    <div
                        className="w-px self-stretch sm:hidden"
                        style={{
                            background: `linear-gradient(to bottom, transparent 0%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 18%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 82%, transparent 100%)`,
                        }}
                    />

                    {/* ══ Column 3 — Newsletter + Social ══ */}
                    <div className="flex-1 px-8 sm:px-0 flex flex-col gap-3">
                        <div className='flex gap-2 items-center mb-1'>
                            <div
                                className="w-[5px] h-5 rounded-full"
                                style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixMedium }}
                                />
                            <div
                                className="text-[14px] font-semibold uppercase tracking-[0.2em]"
                                style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                Our Kitchen
                            </div>
                            </div>
                            {sellerMarketingLine1 && (
                                <div className='bg-white rounded-2xl p-2'>
                                    <div className="text-sm leading-relaxed font-medium" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        <div className="flex items-center gap-0.5" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                            <div>
                                                <div
                                                    className="inline-flex items-center justify-center w-14 h-14 rounded-xl mb-0 mr-1"
                                                    style={{ backgroundColor: `${sellerPrimaryColor1}${sellerColorSuffixLight}` }}>
                                                    <SiteBadge iconType={'Menu'} iconSize={'40'} badgeSize={'52'} />
                                                </div>
                                            </div>
                                            <div className='text-[13px]'>
                                                {sellerMarketingLine1}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Newsletter — highlighted panel */}
                            <div className="bg-white">
                                <div
                                    className="mt-auto rounded-2xl p-3 flex flex-col gap-3"
                                    style={{
                                        backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                        border: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixMedium}`,
                                    }}>
                                    <div className="text-xs font-semibold" style={{ color: sellerPrimaryColor1 }}>
                                        Stay in the loop — join our newsletter
                                    </div>
                                    <form onSubmit={handleNewsletterSubmit} className="flex flex-col gap-2">
                                        <input
                                            required
                                            type="email"
                                            name="email"
                                            id="email"
                                            placeholder="Your email address"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)}
                                            className="w-full px-4 py-2.5 text-sm rounded-2xl outline-none transition-all duration-200 focus:shadow-sm"
                                            style={{
                                                color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                backgroundColor: sellerSecondaryColor1 + sellerColorSuffixLight,
                                                border: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixMedium}`,
                                            }}
                                        />
                                        <button
                                            type="submit"
                                            className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-2xl text-sm font-semibold text-white shadow-sm hover:shadow-md hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 cursor-pointer"
                                            style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                            <BsEnvelopeOpenFill className="text-base" />
                                            Sign Up
                                        </button>
                                    </form>
                                </div>
                            </div>

                            {sellerBoolShowSocialMedia && (
                                <div className="mt-auto">
                                    <div
                                        className="text-[10px] font-semibold uppercase tracking-[0.2em] mb-3"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        Follow Us
                                    </div>
                                    <div className="flex items-center gap-2">
                                        {[
                                            { href: 'https://facebook.com', icon: <FaFacebookF />, label: 'Facebook', bg: '#4f46e5' },
                                            { href: 'https://twitter.com',  icon: <FaTwitter />,   label: 'Twitter',  bg: '#06b6d4' },
                                            { href: 'https://linkedin.com', icon: <FaLinkedin />,  label: 'LinkedIn', bg: '#a855f7' },
                                            { href: 'https://github.com',   icon: <FaGithub />,    label: 'GitHub',   bg: '#3b82f6' },
                                        ].map(({ href, icon, label, bg }) => (
                                            <a
                                                key={label}
                                                href={href}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                aria-label={label}
                                                className="w-8 h-8 flex justify-center items-center rounded-full text-white text-sm shadow-sm hover:shadow-md hover:scale-110 transition-all duration-200"
                                                style={{ backgroundColor: bg }}>
                                                {icon}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                {/* ── Horizontal rule before bottom bar ── */}
                <div
                    className="mt-4 mb-4 h-px w-full"
                    style={{
                        background: `linear-gradient(to right, transparent 0%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 20%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 80%, transparent 100%)`,
                    }}
                />

                {/* ── Bottom bar ── */}
                <div
                    className="grid grid-cols-3 sm:grid-cols-1 gap-3 text-xs font-medium text-center"
                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                    <a href={CONTACT_EMAIL} className="hover:underline transition-all duration-150">
                        Kosher Caterer Website Software
                    </a>
                    <a
                        href={CONTACT_EMAIL}
                        className="font-semibold hover:underline transition-all duration-150"
                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                        Designed &amp; Developed by Platinum Event Management LLC
                    </a>
                    <a href={CONTACT_EMAIL} className="hover:underline transition-all duration-150">
                        Copyright &copy;{currentYear} · All Rights Reserved
                    </a>
                </div>
            </div>

            {/* ── Mobile floating sidebar backdrop-blur-sm ── */}
            {userInfo && (
                <div
                    className="hidden fixed md-lg:flex flex-col items-center justify-center gap-4 w-14 py-6 bottom-4 
                    right-2 rounded-full transition-all duration-300"
                    style={{
                        backgroundColor: sellerSecondaryColor1 + sellerColorSuffixDark,
                        border: `3px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                        //boxShadow: `0 8px 32px ${sellerPrimaryColor1}${sellerColorSuffixMedium}`,
                    }}>
                    {/* Accent pip */}
                    <div
                        className="hidden absolute -top-px left-1/2 -translate-x-1/2 w-5 h-[0px] rounded-full"
                        style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }} />
                    {/* Cart hover:scale-110 */}
                    <div
                        onClick={() => navigate('/cart')}
                        className={`${isCouponValid ? 'h-20' : 'h-14'} 
                            w-9 relative flex flex-col justify-center items-center   
                            cursor-pointer rounded-full transition-all duration-200 mt-1`}
                        style={{ backgroundColor: sellerPrimaryColor1 + '32' }}>
                        <MdOutlineRestaurantMenu className="text-xl mb-0.5" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
                        <FaCartShopping className="text-base" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
                        {cart_product_count > 0 && (
                            <span className="absolute -top-3 -right-0.5 min-w-[30px] h-5 px-1 flex justify-center 
                                items-center rounded-full bg-rose-400 text-white text-[12px] font-bold">
                                {cart_product_count}
                            </span>
                        )}
                        <BiSolidCoupon size={18} className={isCouponValid ? '' : 'hidden'} 
                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}/>
                    </div>

                    {/* Wishlist hover:scale-110 */}
                    {sellerBoolShowSiteWishList && (
                        <div
                            onClick={() => navigate('/customerDashboard/myWishlist')}
                            className="relative flex flex-col justify-center items-center cursor-pointer w-9 h-14 
                                rounded-full transition-all duration-200"
                            style={{ backgroundColor: sellerPrimaryColor1 + '32' }}>
                            <MdOutlineRestaurantMenu className="text-xl mb-0.5" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
                            <FaHeart className="text-base" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }} />
                            {wishlist_count > 0 && (
                                <span className="absolute -top-3 -right-0.5 min-w-[30px] h-5 px-1 flex justify-center 
                                    items-center rounded-full bg-rose-400 text-white text-[12px] font-bold">
                                    {wishlist_count}
                                </span>
                            )}
                        </div>
                    )}
                </div>
            )}
        </footer>
    );
};

export default Footer;


// original code before redesign
// import React, { useEffect, useState, useMemo } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useNavigate } from 'react-router-dom';

// import { FaFacebookF, FaLinkedin, FaGithub } from "react-icons/fa";
// import { FaTwitter, FaHeart, FaCartShopping } from "react-icons/fa6";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { BsEnvelopeOpenFill } from "react-icons/bs";

// import { newsletterSubscriber_register, messageClear } from '../store/reducers/newsletterSubscriberReducer';
// import { toTitleCase } from '../components/toTitleCase';
// import toast from 'react-hot-toast';
// import { formatPhoneNumber } from 'react-phone-number-input';

// import config from '../config';

// const KOSHER_LOGO_MAP = {
//     OU:  '/images/kashrus/OU-Logo-Footer.png',
//     CRC: '/images/kashrus/CRC-Logo-Footer.png',
//     KCL: '/images/kashrus/KCL-Logo-Footer.png',
// };

// const CONTACT_EMAIL = 'mailto:kosher.caterer@inbox.lv?subject=I Would Like More Info About Kosher Caterer Website Software';

// const Footer = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL;

//     const { seller }                              = useSelector(state => state.seller);
//     const { userInfo }                            = useSelector(state => state.auth);
//     const { cart_product_count, wishlist_count }  = useSelector(state => state.cart);
//     const { errorMessage, successMessage }        = useSelector(state => state.newsletterSubscriber);

//     const [email, setEmail] = useState('');

//     const s = seller ?? {};

//     const primaryColor1    = s.frontEndPrimaryColor1;
//     const primaryColor2    = s.frontEndPrimaryColor2;
//     const secondaryColor1  = s.frontEndSecondaryColor1;

//     const showWishlist     = s.isVisibleSiteWishlist    === 'Show';
//     const showSocialMedia  = s.isVisibleSiteSocialMedia === 'Show';
//     const showChat         = s.isVisibleSiteChat        === 'Show';

//     const kosherLogo1 = KOSHER_LOGO_MAP[s.kosherSupervision1] ?? '';
//     const kosherLogo2 = KOSHER_LOGO_MAP[s.kosherSupervision2] ?? '';

//     const ownerNames = useMemo(() => {
//         const raw = s.ownerNames ?? '';
//         return raw.includes(';') ? raw.split(';') : raw ? [raw] : [];
//     }, [s.ownerNames]);

//     const currentYear = new Date().getFullYear();

//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     const handleChatClick = () => {
//         navigate(userInfo ? '/customerDashboard/chat' : '/login');
//     };

//     const handleNewsletterSubmit = (e) => {
//         e.preventDefault();
//         dispatch(newsletterSubscriber_register({
//             webSiteOrigin: sellerFrontendURL,
//             email,
//             isSubscribed: true,
//         }));
//         setEmail('');
//     };

//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage, dispatch]);

//     return (
//         <footer style={{ backgroundColor: secondaryColor1, color: primaryColor1, borderColor: primaryColor1 }}>

//             {/* ── Main grid ── */}
//             <div className='w-[80%] flex flex-wrap mx-auto py-2 pb-2'>

//                 {/* About Us column */}
//                 <div className='w-3/12 sm:w-full items-center justify-center justify-items-center'>
//                     <div className='w-full'>
//                         <table>
//                             <tbody>
//                                 <tr>
//                                     <td colSpan={2} className='font-bold text-lg mb-1'>About Us (A Little)</td>
//                                 </tr>
//                                 <tr>
//                                     <td>
//                                         <img
//                                             className='ml-2 w-[140px] h-[51px]'
//                                             src={s.logoImage}
//                                             alt={`${s.shopName} logo`}
//                                         />
//                                     </td>
//                                     <td>
//                                         <img
//                                             className='w-[50px] h-[50px] rounded-lg'
//                                             src={s.sellerImage}
//                                             alt={`${s.shopName} seller`}
//                                         />
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td align='center' colSpan={2} className='text-sm mb-1'>
//                                         {ownerNames.map((name, i) => (
//                                             <span key={i}>{toTitleCase(name)}{i < ownerNames.length - 1 ? ', ' : ''}</span>
//                                         ))}
//                                         {ownerNames.length > 1 && <br />}
//                                         <span>At Your Service!</span>
//                                     </td>
//                                 </tr>
//                                 <tr>
//                                     <td align='center' colSpan={2} className='text-sm mb-1'>
//                                         {kosherLogo1 && (
//                                             <img src={kosherLogo1} alt={`${s.kosherSupervision1} certification`} />
//                                         )}
//                                         {kosherLogo2 && (
//                                             <img src={kosherLogo2} alt={`${s.kosherSupervision2} certification`} />
//                                         )}
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//                 {/* Contact Info column */}
//                 <div className='sm:w-full w-6/12'>
//                     <div className='flex justify-center sm:mt-6 w-full'>
//                         <div>
//                             <div className='font-bold text-lg mb-1' style={{ color: primaryColor1 }}>Contact Info</div>
//                             <div className='flex justify-between gap-[30px] lg:gap-[10px]'>
//                                 <ul className='flex flex-col ml-2 gap-2 text-sm' style={{ color: primaryColor1, fontWeight: '500' }}>
//                                     <li>{s.shopName}</li>
//                                     <li>{s.address1} {s.address2}</li>
//                                     <li>{s.city}, {s.sellerState} {s.zipCode}</li>
//                                 </ul>
//                                 <ul className='flex flex-col gap-2 text-sm' style={{ color: primaryColor1, fontWeight: '500' }}>
//                                     <li>Phone: {formatPhoneNumber(s.phoneNumber)}</li>
//                                     <li>Contact: {s.contactPerson}</li>
//                                     <li>Email: {s.emailAddress}</li>
//                                 </ul>
//                             </div>

//                             {showChat && (
//                                 <div
//                                     onClick={handleChatClick}
//                                     className='mt-2 px-1 py-1 text-md font-semibold flex h-[34px] w-full justify-center items-center rounded-lg cursor-pointer text-white'
//                                     style={{ backgroundColor: primaryColor1 }}
//                                 >
//                                     <IoChatbubbleEllipsesSharp className='mr-2' />
//                                     Chat With Us
//                                 </div>
//                             )}

//                             {s.otherWebsiteURL2 && (
//                                 <div className='w-full text-center mt-1'>
//                                     <Link
//                                         className='hover:underline'
//                                         target="_blank"
//                                         rel="noopener noreferrer"
//                                         to={s.otherWebsiteURL2}
//                                     >
//                                         {s.otherWebsiteName2}
//                                     </Link>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>

//                 {/* Newsletter / Social column */}
//                 <div className='sm:w-full w-3/12'>
//                     <div className='flex justify-center sm:mt-6 w-full'>
//                         <div>
//                             <div className='font-bold text-lg mb-1' style={{ color: primaryColor1 }}>
//                                 About Our Kitchen
//                             </div>
//                             <div className='flex ml-2 justify-between text-sm' style={{ color: primaryColor1, fontWeight: '500' }}>
//                                 {s.marketingLine1}
//                             </div>

//                             <form onSubmit={handleNewsletterSubmit}>
//                                 <div className='flex flex-col ml-2 gap-1' style={{ color: primaryColor1 }}>
//                                     <input
//                                         required
//                                         type="email"
//                                         name='email'
//                                         id='email'
//                                         placeholder='Email Address'
//                                         value={email}
//                                         onChange={e => setEmail(e.target.value)}
//                                         className='px-2 py-1 mt-1 outline-none border border-slate-400 bg-transparent rounded-md'
//                                     />
//                                     <button
//                                         type="submit"
//                                         className='mt-1 px-1 py-1 text-md font-semibold flex h-[34px] w-full justify-center items-center rounded-lg cursor-pointer text-white'
//                                         style={{ backgroundColor: primaryColor1 }}
//                                     >
//                                         <BsEnvelopeOpenFill className='mr-2' />
//                                         Newsletter SignUp
//                                     </button>
//                                 </div>
//                             </form>

//                             {showSocialMedia && (
//                                 <div className='mt-2'>
//                                     <ul className='flex justify-start items-center gap-3'>
//                                         <li className='font-semibold' style={{ color: primaryColor1 }}>Share On</li>
//                                         <li>
//                                             <a
//                                                 className='w-[38px] h-[38px] flex justify-center items-center bg-indigo-500 rounded-full text-white'
//                                                 href="https://facebook.com"
//                                                 target="_blank"
//                                                 rel="noopener noreferrer"
//                                                 aria-label="Facebook"
//                                             >
//                                                 <FaFacebookF />
//                                             </a>
//                                         </li>
//                                         <li>
//                                             <a
//                                                 className='w-[38px] h-[38px] flex justify-center items-center bg-cyan-500 rounded-full text-white'
//                                                 href="https://twitter.com"
//                                                 target="_blank"
//                                                 rel="noopener noreferrer"
//                                                 aria-label="Twitter / X"
//                                             >
//                                                 <FaTwitter />
//                                             </a>
//                                         </li>
//                                         <li>
//                                             <a
//                                                 className='w-[38px] h-[38px] flex justify-center items-center bg-purple-500 rounded-full text-white'
//                                                 href="https://linkedin.com"
//                                                 target="_blank"
//                                                 rel="noopener noreferrer"
//                                                 aria-label="LinkedIn"
//                                             >
//                                                 <FaLinkedin />
//                                             </a>
//                                         </li>
//                                         <li>
//                                             <a
//                                                 className='w-[38px] h-[38px] flex justify-center items-center bg-blue-500 rounded-full text-white'
//                                                 href="https://github.com"
//                                                 target="_blank"
//                                                 rel="noopener noreferrer"
//                                                 aria-label="GitHub"
//                                             >
//                                                 <FaGithub />
//                                             </a>
//                                         </li>
//                                     </ul>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* ── Bottom bar ── */}
//             <div
//                 className='w-[80%] flex flex-wrap mx-auto border-b py-2 pb-4'
//                 style={{ color: primaryColor1, fontSize: '14px', fontWeight: '500' }}
//             >
//                 <div className='2xs:w-full xs:w-full sm:w-full w-3/12 text-center'>
//                     <a href={CONTACT_EMAIL} className='hover:underline'>
//                         Kosher Caterer Website Software
//                     </a>
//                 </div>
//                 <div className='2xs:w-full xs:w-full sm:w-full w-6/12 text-center'>
//                     <a
//                         href={CONTACT_EMAIL}
//                         className='hover:underline'
//                         style={{ borderColor: primaryColor1, paddingLeft: '10px', paddingRight: '10px' }}
//                     >
//                         Designed And Developed By Platinum Event Management LLC
//                     </a>
//                 </div>
//                 <div className='2xs:w-full xs:w-full sm:w-full w-3/12 text-center'>
//                     <a href={CONTACT_EMAIL} className='hover:underline'>
//                         Copyright &copy;{currentYear}, All Rights Reserved
//                     </a>
//                 </div>
//             </div>

//             {/* ── Mobile floating sidebar ── */}
//             {userInfo && (
//                 <div className='hidden fixed border md-lg:block w-[50px] h-[210px] pt-6 bottom-4 right-1 bg-white rounded-full p-2'
//                     style={{ borderColor: primaryColor1 }}
//                 >
//                     <div className='w-full h-full flex gap-5 flex-col justify-center items-center'>

//                         {/* Cart */}
//                         <div
//                             onClick={() => navigate('/cart')}
//                             className='relative flex justify-center items-center cursor-pointer mb-2 w-[35px] h-[70px] rounded-full'
//                             style={{ backgroundColor: secondaryColor1 }}
//                         >
//                             <span className='text-xl' style={{ color: primaryColor1 }}>
//                                 <MdOutlineRestaurantMenu className='pb-1 text-3xl' />
//                                 <FaCartShopping className='pl-1 text-2xl' />
//                             </span>
//                             {cart_product_count > 0 && (
//                                 <div className='w-[30px] h-[22px] absolute bg-red-500 rounded-full text-white flex justify-center items-center -top-[15px] -right-[-2px]'>
//                                     {cart_product_count}
//                                 </div>
//                             )}
//                         </div>

//                         {/* Wishlist */}
//                         {showWishlist && (
//                             <div
//                                 onClick={() => navigate('/customerDashboard/myWishlist')}
//                                 className='relative flex justify-center items-center cursor-pointer rounded-full w-[35px] h-[70px]'
//                                 style={{ backgroundColor: secondaryColor1 }}
//                             >
//                                 <span className='text-xl' style={{ color: primaryColor1 }}>
//                                     <MdOutlineRestaurantMenu className='pb-1 text-3xl' />
//                                     <FaHeart className='pl-1 text-2xl' />
//                                 </span>
//                                 {wishlist_count > 0 && (
//                                     <div className='w-[30px] h-[22px] absolute bg-red-500 rounded-full text-white flex justify-center items-center -top-[15px] -right-[0px]'>
//                                         {wishlist_count}
//                                     </div>
//                                 )}
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             )}
//         </footer>
//     );
// };

// export default Footer;






//my original code
// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useLocation, useNavigate } from 'react-router-dom';

// import { FaFacebookF, FaLinkedin, FaGithub} from "react-icons/fa";
// import { FaTwitter, FaHeart, FaCartShopping } from "react-icons/fa6";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { BsEnvelopeOpenFill } from "react-icons/bs";

// import { newsletterSubscriber_register, messageClear } from '../store/reducers/newsletterSubscriberReducer'
// import { toTitleCase } from '../components/toTitleCase';
// import toast from 'react-hot-toast';
// import { formatPhoneNumber } from 'react-phone-number-input'
// import Moment from 'moment/moment';
// import SkeletonWithImage from './SkeletonWithImage';

// import config from '../config';

// import { Text } from '@react-pdf/renderer';

// const Footer = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL 

//     const { seller } = useSelector(state => state.seller)
//     const { userInfo } = useSelector(state => state.auth) 
//     const { cart_product_count, wishlist_count } = useSelector(state => state.cart) 
//     const { errorMessage, successMessage } = useSelector(state => state.newsletterSubscriber)
//     //newsletterSubscriber_register

//     let [state, setState] = useState({
//         webSiteOrigin: sellerFrontendURL, firstName: '', lastName: '', email: '', isSubscribed: true
//     })

//     const sellerId = seller?._id 
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
//     const sellerPrimaryColor2 =  seller?.frontEndPrimaryColor2
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1    
//     const sellerCompanyPhoneNumber = seller?.phoneNumber
//     const sellerCompanyLogo = seller?.logoImage
//     const sellerImage = seller?.sellerImage
//     const sellerCompanyEmailAddress = seller?.emailAddress
//     const sellerCompanyKosherSupervision1 = seller?.kosherSupervision1
//     const sellerCompanyKosherSupervision2 = seller?.kosherSupervision2
//     const sellerCompanyMarketingLine1 = seller?.marketingLine1
//     const sellerCompanyOwnerNames = seller?.ownerNames
//     const sellerCompanyName = seller?.shopName
//     const sellerCompanyAddress1 = seller?.address1
//     const sellerCompanyAddress2 = seller?.address2
//     const sellerCompanyCity = seller?.city
//     const sellerCompanyState = seller?.sellerState
//     const sellerCompanyZipCode = seller?.zipCode
//     const sellerCompanyContactPerson = seller?.contactPerson
//     const sellerOtherWebsiteURL2 = seller?.otherWebsiteURL2
//     const sellerOtherWebsiteName2 = seller?.otherWebsiteName2
    
//     const sellerBoolShowSiteWishList = seller?.isVisibleSiteWishlist === 'Show' ? true : false
//     const sellerBoolShowSiteSocialMedia = seller?.isVisibleSiteSocialMedia === 'Show' ? true : false
//     const sellerBoolShowSiteChat = seller?.isVisibleSiteChat === 'Show' ? true : false
    
//     const todayDate = new Date()
//     const contactUsEmail = 'mailto:kosher.caterer@inbox.lv?subject=I Would Like More Info About Kosher Caterer Website Software'
    
//     let footerKosherSupervisionURL1 = ''
    
//     if (sellerCompanyKosherSupervision1=== 'OU') {
//         footerKosherSupervisionURL1 = '/images/kashrus/OU-Logo-Footer.png'
//     } else if (sellerCompanyKosherSupervision1 === 'CRC') {
//         footerKosherSupervisionURL1 = '/images/kashrus/CRC-Logo-Footer.png'
//     } else if (sellerCompanyKosherSupervision1 === 'KCL') {
//         footerKosherSupervisionURL1 = '/images/kashrus/KCL-Logo-Footer.png'
//     }
    
//     let footerKosherSupervisionURL2 = ''

//     if (sellerCompanyKosherSupervision2 === 'OU') {
//         footerKosherSupervisionURL2 = '/images/kashrus/OU-Logo-Footer.png'
//     } else if (sellerCompanyKosherSupervision2 === 'CRC') {
//         footerKosherSupervisionURL2 = '/images/kashrus/CRC-Logo-Footer.png'
//     } else if (sellerCompanyKosherSupervision2 === 'KCL') {
//         footerKosherSupervisionURL2 = '/images/kashrus/KCL-Logo-Footer.png'
//     }

//     let arrOwnerNames = []
//     try {
//         if (sellerCompanyOwnerNames.includes(';')) {
//             arrOwnerNames = sellerCompanyOwnerNames.split(';')
//         } else {
//             arrOwnerNames[0] = sellerCompanyOwnerNames
//         }
//     } catch (error) {
        
//     }

//     const dispatch = useDispatch()
//     const navigate = useNavigate() 

//     const redirect_chat_page = () => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat`)
//             ///${sellerId}
//         } else {
//             navigate('/login')
//         }
//     }

//     const newsletterSubscribe_register_local = (e) => {
//         e.preventDefault()
//         dispatch(newsletterSubscriber_register(state))
//         setState({
//             ...state,
//             email: ''
//         })
//     }
//     const inputHandle = (e) => {
//         setState({
//             ...state,
//             [e.target.name]: e.target.value
//         })
//     }

//     useEffect(() => { 
//         if (successMessage) {
//             toast.success(successMessage)
//             //send newletter
//             dispatch(messageClear())  
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             dispatch(messageClear())  
//         } 
//     },[successMessage, errorMessage])

//     return (
//         <footer className='' style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}} >
//             <div className='w-[80%] flex flex-wrap mx-auto py-2 pb-2'>
//                 <div className='w-3/12 sm:w-full items-center justify-center justify-items-center border-none border-black'>
//                     <div className='hidden justify-start w-full font-bold text-lg mb-1'>About Us (A Little)</div>
//                     <div className='w-full border-none border-red-500 justify-start'>
//                         <div className='w-full border-none border-blue-500 items-center justify-center justify-items-center'>
//                             <table>
//                                 <tbody>
//                                     <tr>
//                                         <td colSpan={2} className='font-bold text-lg mb-1'>
//                                             About Us (A Little)
//                                         </td>
//                                     </tr>
//                                     <tr className='border-none border-black'>
//                                         <td>
//                                             <img className='ml-2 w-[140px] h-[51px] border-none border-black' src={sellerCompanyLogo} alt="logopng" />
//                                         </td>
//                                         <td>
//                                             <img className="w-[50px] h-[50px] border-none border-black rounded-lg" src={sellerImage} alt="sellerImage" />
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td align='center' colSpan={2} className='text-sm mb-1'>
//                                             {
//                                                 arrOwnerNames.map((p,i) => {
//                                                     return( toTitleCase(p) + ', ' )
//                                                 })
//                                             }
//                                             <span className={` ${arrOwnerNames.length > 1 ? '' : 'hidden' } `}><br /></span>
//                                             <span>At Your Service!</span>
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td align='center' colSpan={2} className='text-sm mb-1'>
//                                             <span>
//                                                 <img className={` ${sellerCompanyKosherSupervision1 !== 'None' ? '' : 'hidden'} `} src={footerKosherSupervisionURL1}  alt='KosherLogo' />
//                                             </span>
//                                             <span>
//                                                 <img className={` ${sellerCompanyKosherSupervision2 !== 'None' ? '' : 'hidden'} `} src={footerKosherSupervisionURL2}  alt='KosherLogo' />
//                                             </span>
//                                         </td>
//                                     </tr>
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 </div>
//                 <div className='sm:w-full w-6/12 border-none border-black'>
//                     <div className='flex justify-center sm:mt-6 w-full'>
//                         <div>
//                             <div className='font-bold text-lg mb-1' style={{color:sellerPrimaryColor1}}>Contact Info</div>
//                             <div className='flex justify-between gap-[30px] lg:gap-[10px]'>
//                                 <ul className='flex flex-col ml-2 gap-2 text-sm' 
//                                     style={{color:sellerPrimaryColor1, fontWeight:'500'}}>
//                                     <li>{sellerCompanyName}</li>
//                                     <li>{sellerCompanyAddress1} {sellerCompanyAddress2}</li>
//                                     <li>{sellerCompanyCity}, {sellerCompanyState} {sellerCompanyZipCode}</li>
//                                     {
//                                         // <li><Link>About Us </Link></li>
//                                         // <li><Link>About Our Shop </Link></li>
//                                         // <li><Link>Delivery Information </Link></li>
//                                         // <li><Link>Privacy Policy</Link></li>
//                                         // <li><Link>Blogs</Link></li>
//                                     }
//                                 </ul>
//                                 <ul className='flex flex-col gap-2 text-sm' 
//                                     style={{color:sellerPrimaryColor1, fontWeight:'500'}}>
//                                     <li>Phone: {formatPhoneNumber(sellerCompanyPhoneNumber)}</li>
//                                     <li>Contact: {sellerCompanyContactPerson}</li>
//                                     <li>Email: {sellerCompanyEmailAddress}</li>
//                                 </ul>
//                                 {
                                       
//                                     //     <li><Link>Our Service </Link></li>
//                                     //     <li><Link>Company Profile</Link></li>
//                                     //     <li><Link>Privacy Policy </Link></li>
//                                     //     <li><Link>Blogs  </Link></li>
//                                 }
//                             </div>
//                             <div className='w-full items-center justify-center'>
//                                 <div onClick={redirect_chat_page} 
//                                     className={` ${sellerBoolShowSiteChat ? '' : 'hidden' } 
//                                     mt-2 px-1 py-1 text-md font-semibold flex h-[34px] w-full justify-center items-center rounded-lg  
//                                     cursor-pointer text-white `}
//                                     style={{backgroundColor:sellerPrimaryColor1}}>
//                                     <IoChatbubbleEllipsesSharp className='mr-2' />Chat With Us
//                                 </div>
//                             </div>
//                             <div className='w-full items-center justify-center text-center'>
//                                 <span className={` ${sellerOtherWebsiteURL2 === '' ? 'hidden' : '' }  `}>
//                                     <Link className='hover:underline' target="_blank" to={`${sellerOtherWebsiteURL2}`}>
//                                         {sellerOtherWebsiteName2}
//                                     </Link>
//                                 </span>
//                             </div>
//                         </div> 
//                     </div> 
//                 </div>
//                 <div className='sm:w-full w-3/12 border-none border-black'>
//                     <div className='flex justify-center sm:mt-6 w-full'>
//                         <div>
//                             <div className='font-bold text-lg mb-1' style={{color:sellerPrimaryColor1}}>
//                                 About Our Kitchen
//                             </div>
//                             <div className='flex ml-2 justify-between text-sm' 
//                                 style={{color:sellerPrimaryColor1, fontWeight:'500'}}>
//                                 {sellerCompanyMarketingLine1}
//                             </div>
//                             <form onSubmit={newsletterSubscribe_register_local}>
//                                 <div className='flex flex-col ml-2 gap-1' style={{ color: sellerPrimaryColor1 }}>
//                                     <input required onChange={inputHandle} value={state.email} type="text" name='email' placeholder='Email Address' id='email'  
//                                         className='px-2 py-1 mt-1 outline-none border border-slate-400 bg-transparent rounded-md' />
//                                     <button className='mt-1 px-1 py-1 text-md font-semibold flex h-[34px] w-full justify-center 
//                                         items-center rounded-lg cursor-pointer text-white' 
//                                         style={{backgroundColor:sellerPrimaryColor1}}>
//                                         <BsEnvelopeOpenFill  className='mr-2' />
//                                         Newsletter SignUp
//                                     </button>
//                                 </div>
//                             </form>
//                             <div className={` ${sellerBoolShowSiteSocialMedia ? 'mt-2' : 'hidden' } `}>
//                                 <ul className='flex justify-start items-center gap-3'>
//                                     <li className={`font-semibold`} style={{color:sellerPrimaryColor1}}>Share On</li>
//                                     <li>
//                                         <a className='w-[38px] h-[38px] flex justify-center items-center bg-indigo-500 rounded-full text-white' href="#">
//                                             <FaFacebookF />
//                                         </a>
//                                     </li>
//                                     <li>
//                                         <a className='w-[38px] h-[38px] flex justify-center items-center bg-cyan-500 rounded-full text-white' href="#">
//                                             <FaTwitter />
//                                         </a>
//                                     </li>
//                                     <li>
//                                         <a className='w-[38px] h-[38px] flex justify-center items-center bg-purple-500 rounded-full text-white' href="#">
//                                             <FaLinkedin />
//                                         </a>
//                                     </li>
//                                     <li>
//                                         <a className='w-[38px] h-[38px] flex justify-center items-center bg-blue-500 rounded-full text-white' href="#">
//                                             <FaGithub />
//                                         </a>
//                                     </li>
//                                 </ul> 
//                             </div>
//                         </div>
                        
//                     </div>
//                 </div>
//             </div>
//             {
//                 //flex w-[70%] flex-wrap justify-center items-center mx-auto pb-4 text-center text-
//                 // className='2xs:text-[16px] xs:text-[16px] sm:text-[16px] md:text-md md-lg:text-md 
//                 //             lg:text-2xl xl:text-2xl 2xl:text-2xl 3xl:text-2xl 4xl:text-2xl 
//                 //             flex curser-pointer hover:underline text-white rounded-xl border py-1 px-3 
//                 //             justify-center items-center'
//                 // w-full grid grid-cols-3
//             }
//             <div className='w-[80%] flex flex-wrap mx-auto border-b py-2 pb-4' 
//                 style={{color:sellerPrimaryColor1, fontSize:'14px', fontWeight:'500'}}>
//                 <div className='2xs:w-full xs:w-full sm:w-full w-3/12 text-center border-none border-black'>
//                     <a href={contactUsEmail} className='hover:underline' >
//                         Kosher Caterer Website Software
//                     </a>
//                 </div>
//                 <div className='2xs:w-full 2xs:border-none xs:w-full xs:border-none sm:w-full sm:border-none 
//                     w-6/12 text-center border-none border-black' 
//                     style={{}}>
//                     <a href={contactUsEmail} className='hover:underline' 
//                         style={{borderColor:sellerPrimaryColor1,paddingLeft:'10px', paddingRight:'10px'}}>
//                         Designed And Developed By Platinum Event Management LLC
//                     </a>
//                 </div>
//                 <div className='2xs:w-full xs:w-full sm:w-full w-3/12 text-center border-none border-black'>
//                     <a href={contactUsEmail} className='hover:underline'>
//                         Copyright @{Moment(todayDate).format('yyyy')},&nbsp;All Rights Reserved
//                     </a>
//                 </div>
//             </div>
//             {/*slider on lower right in mobile view*/}
//             <div className={`${userInfo ? '' : 'hidden'}`} >
//                 {/* z-50 */}
//                 <div className={`hidden fixed border md-lg:block w-[50px] h-[210px] pt-6 bottom-4 right-1  bg-white rounded-full p-2`}
//                     style={{borderColor:sellerPrimaryColor1}}>
//                     <div className='w-full h-full flex gap-5 flex-col justify-center items-center border-none'>
//                         <div onClick={() => navigate(userInfo ? '/cart' : '/login') }  
//                             className='relative flex justify-center items-center cursor-pointer mb-2 w-[35px] h-[70px] rounded-full' 
//                             style={{backgroundColor:sellerSecondaryColor1}}>
//                             <span className='text-xl' style={{color:sellerPrimaryColor1}}>
//                                 <MdOutlineRestaurantMenu className='pb-1 text-3xl' />
//                                 <FaCartShopping className='pl-1 text-2xl'/>
//                             </span>
//                             {
//                                 cart_product_count !== 0 && 
//                                 <div className='w-[30px] h-[22px] absolute bg-red-500 rounded-full text-white flex 
//                                     justify-center items-center -top-[15px] -right-[-2px]'>
//                                     {
//                                         cart_product_count
//                                     }
//                                 </div>
//                             }
//                         </div>
//                         <div onClick={() => navigate(userInfo ? '/customerDashboard/myWishlist' : '/login') } 
//                             className={` ${sellerBoolShowSiteWishList ? '' : 'hidden'} 
//                             relative flex justify-center items-center cursor-pointer rounded-full w-35px] h-[70px] `}
//                             style={{backgroundColor:sellerSecondaryColor1}}>
//                             <span className='text-xl' style={{color:sellerPrimaryColor1}}>
//                                 <MdOutlineRestaurantMenu className='pb-1 text-3xl' />
//                                 <FaHeart className='pl-1 text-2xl' />
//                             </span>
//                             {
//                                 wishlist_count !== 0 && 
//                                 <div className='w-[30px] h-[22px] absolute bg-red-500 rounded-full text-white flex 
//                                     justify-center items-center -top-[15px] -right-[0px]'>
//                                     {
//                                         wishlist_count 
//                                     }
//                                 </div>
//                             }
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </footer>
//     );
// };

// export default Footer;






